export class SpeedViolationTracker {
    constructor() {
        this.violations = [];
    }
    sample(speed, threshold, timestamp, stage) {
        if (speed <= threshold) {
            this.endEpisode(timestamp);
            return;
        }
        if (this.currentViolation === undefined) {
            this.currentViolation = { speed, timestamp, stage, durationMs: 0 };
            this.violations.push(this.currentViolation);
        }
        else if (speed > this.currentViolation.speed) {
            this.currentViolation.speed = speed;
        }
        this.currentViolation.durationMs = Math.max(this.currentViolation.durationMs, timestamp - this.currentViolation.timestamp);
    }
    endEpisode(timestamp) {
        if (this.currentViolation !== undefined && timestamp !== undefined) {
            this.currentViolation.durationMs = Math.max(this.currentViolation.durationMs, timestamp - this.currentViolation.timestamp);
        }
        this.currentViolation = undefined;
    }
    reset(violations = []) {
        this.violations = violations;
        this.endEpisode();
    }
}
